<template>
  <div :class="{ 'pb-[80px]': audioState.story }">
    <router-view />
  </div>
  <AudioPlayer v-if="audioState.story" />
</template>

<script>
import { inject } from 'vue';
import AudioPlayer from '@/components/AudioPlayer.vue';

export default {
  name: 'App',
  components: {
    AudioPlayer
  },
  setup() {
    const audioState = inject('audioState');
    return { audioState };
  },
  methods: {
    applyTheme() {
        if (localStorage.getItem('theme') === 'light') {
            document.body.classList.add('light-mode');
        } else {
            document.body.classList.remove('light-mode');
        }
    }
  },
  created() {
    this.applyTheme();
  }
};
</script>

<style>
/* TOÀN BỘ CSS CHO THEME ĐƯỢC CHUYỂN VÀO ĐÂY */
:root {
    --bg-color: #121212;
    --card-bg-color: #1e1e1e;
    --text-color: #e0e0e0;
    --text-muted-color: #a0a0a0;
    --border-color: #2d2d2d;
    --primary-color: #3b82f6;
    --card-footer-bg: #2a2a2a;
}

body.light-mode {
    --bg-color: #f3f4f6;
    --card-bg-color: #ffffff;
    --text-color: #1f2937;
    --text-muted-color: #6b7280;
    --border-color: #e5e7eb;
    --card-footer-bg: #f9fafb;
}

body {
    background-color: var(--bg-color);
    color: var(--text-color);
    transition: background-color 0.3s, color 0.3s;
    font-family: 'Inter', sans-serif;
}

/* Các style chung khác có thể đặt ở đây */
#search-input {
    background-color: var(--card-bg-color);
    border: 1px solid var(--border-color);
    color: var(--text-color);
    transition: all 0.2s ease-in-out;
}
</style>
